const initSwiperNews = () => {
  const swiperElement = document.querySelector('[data-swiper="news"]');
  const swiperButtonPrev = document.querySelector('[data-swiper-button-prev="news"]');
  const swiperButtonNext = document.querySelector('[data-swiper-button-next="news"]');

  const swiperButtonPrevMobile = document.querySelector('[data-swiper-button-prev="news-mobile"]');
  const swiperButtonNextMobile = document.querySelector('[data-swiper-button-next="news-mobile"]');

  if (!swiperElement) return;

  const swiper = new Swiper(swiperElement, {
    navigation: {
      nextEl: window.innerWidth > 615 ? swiperButtonNext : swiperButtonNextMobile,
      prevEl: window.innerWidth > 615 ? swiperButtonPrev : swiperButtonPrevMobile,
    },

    breakpoints: {
      0: {
        slidesPerView: 'auto',
      },
      616: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
      1920: {
        slidesPerView: 'auto',
      },
    },
  });
};

export {initSwiperNews};
